import { Response } from 'superagent'
import { sendRequest } from './superagent'

export async function apiGetHearbeat (): Promise<Response> {
  return await sendRequest('get', 'heartbeat')
}
